import React from "react";
import LogoUrl from "./Logo.svg";
import LogoWhiteUrl from "./logo-white.svg";
import LogoFullWhiteUrl from "./logo-full-white.svg";
import { useIntl, defineMessages } from "react-intl";

const appearances = {
  default: LogoUrl,
  full: LogoFullWhiteUrl,
  white: LogoWhiteUrl,
};

const messages = defineMessages({
  logoAlt: {
    id: "layout.Header.logoAlt",
    defaultMessage: "Robertet",
  },
});

const Logo = ({
  appearance = "default",
  ariaHidden = false,
  alt = "",
  lazyLoad = false,
}) => {
  const intl = useIntl();
  const logoUrl = appearances[appearance];
  let logoAlt = "";
  if (alt) {
    logoAlt = alt;
  } else if (!alt && !ariaHidden) {
    logoAlt = intl.formatMessage(messages.logoAlt);
  } else if (alt === undefined && !ariaHidden) {
    logoAlt = "";
  } else if (alt === undefined && ariaHidden) {
    logoAlt = "";
  }

  return (
    <img
      src={logoUrl}
      className="logo"
      alt={logoAlt}
      width="146"
      height="30"
      aria-hidden={ariaHidden}
      loading={lazyLoad ? "lazy" : "eager"}
    />
  );
};

export default Logo;
